<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="true"
        class="ah-detail-dialog accounting-yearly-management-balance-sheet-dialog"
        top="5vh"
        append-to-body
        :before-close="onBeforeClose"
        :lock-scroll="false"
        @open="onOpen"
    >
        <template slot="title">
            <span v-if="year">{{ year - 1911 }}年會計作業紀錄</span>
        </template>
        <div class="action-bar">
            <div>
                <label style="margin-right: 10px;">金額為 0 的科目：</label>
                <el-radio-group v-model="isShowZeroItems" @change="updateData">
                    <el-radio :label="true">顯示</el-radio>
                    <el-radio :label="false">隱藏</el-radio>
                </el-radio-group>
            </div>
            <el-button @click="updateData">重新整理</el-button>
        </div>
        <div class="container">
            <div class="table-view-container">
                <TableView
                    :datas="datas"
                    :totals="totals"
                    :queryParams="queryParams"
                    :settlementDateTxt="settlementDateTxt"
                    :closedDateTxt="closedDateTxt"
                    :isLoading="isLoading"
                    @click="onClickItem"
                />
            </div>
        </div>
        <DetailDialog
            :visible="detailDialog.visible"
            :StartDate="queryParams.startDate"
            :EndDate="queryParams.queryDate"
            :accno="detailDialog.accno"
            :accnam="detailDialog.accnam"
            @close="onDetailDialogClose"
        />
    </el-dialog>
</template>

<script>
import moment from 'moment';
import { fetchYearRawData, formatCategoryItems, countCategoryTotals } from '@/components/dashboard/Accounting/AccountingBalanceSheet/utils';
import TableView from '@/components/dashboard/Accounting/AccountingBalanceSheet/TableView.vue';
// import mixins from '@/components/dashboard/Accounting/AccountingBalanceSheet/mixins';

export default {
    // mixins: [mixins],
    components: {
        TableView,
        DetailDialog: () => import('@/components/ui/ahAccountingGeneralLedgerDialog.vue'),
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        year: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            isLoading: false,
            isShowZeroItems: true,
            queryParams: {
                queryDate: null,
                startDate: null,
            },
            datas: {
                currentAssets: [], // 流動資產
                nonCurrentAssets: [], // 非流動資產
                currentLiabilities: [], // 流動負債
                nonCurrentLiabilities: [], // 非流動負債
                totalEquity: [], // 權益
            },
            totals: {
                currentAssets: 0,
                nonCurrentAssets: 0,
                currentLiabilities: 0,
                nonCurrentLiabilities: 0,
                totalEquity: 0,
                assets: 0,
                liabilities: 0,
                liabilitiesAndEquity: 0,
            },
            detailDialog: {
                visible: false,
                accno: null,
                accnam: null,
            },
            annualAccountingTaskStatus: null,
            settlementDateTxt: null,
            closedDateTxt: null,
        };
    },
    methods: {
        async onOpen() {
            // this.dateRange = [parseInt(moment().year(this.year).format('x'), 10), null];
            this.updateData();
        },
        onDetailDialogClose(refresh) {
            this.detailDialog.visible = false;
            if (refresh) this.updateData();
        },
        async onBeforeClose() {
            this.$emit('close');
        },
        async updateData() {
            this.isLoading = true;

            // 取得資料、開始、結束日期
            const endOfYear = parseInt(moment().year(this.year).endOf('year').format('x'), 10);
            const { startDate, queryDate, rawData } = await fetchYearRawData(endOfYear);
            this.queryParams.startDate = startDate;
            this.queryParams.queryDate = queryDate;

            // 轉換為資產負債表的分類
            const items = formatCategoryItems(rawData, this.isShowZeroItems);
            this.datas.currentAssets = items.currentAssets;
            this.datas.nonCurrentAssets = items.nonCurrentAssets;
            this.datas.currentLiabilities = items.currentLiabilities;
            this.datas.nonCurrentLiabilities = items.nonCurrentLiabilities;
            this.datas.totalEquity = items.totalEquity;

            // 計算每個分類需要的統計
            const totals = countCategoryTotals(items);
            this.totals.currentAssets = totals.currentAssets;
            this.totals.nonCurrentAssets = totals.nonCurrentAssets;
            this.totals.currentLiabilities = totals.currentLiabilities;
            this.totals.nonCurrentLiabilities = totals.nonCurrentLiabilities;
            this.totals.totalEquity = totals.totalEquity;
            this.totals.assets = totals.assets;
            this.totals.liabilities = totals.liabilities;
            this.totals.liabilitiesAndEquity = totals.liabilitiesAndEquity;

            // 結算日期、關帳日期
            this.annualAccountingTaskStatus = rawData.annualAccountingTaskStatus;
            this.settlementDateTxt = moment(rawData.lastSettlementBelongDate).format('YYYY年MM月DD日');
            this.closedDateTxt = this.annualAccountingTaskStatus === 2 ? moment(rawData.lastClosedOperationTime).format('YYYY年MM月DD日') : null;

            this.isLoading = false;
        },
        onClickItem(item) {
            // console.log('click', item);
            this.detailDialog.accno = item.accno;
            this.detailDialog.accnam = item.accnam;
            this.detailDialog.visible = true;
        },
    },
};
</script>

<style lang="scss">
.accounting-yearly-management-balance-sheet-dialog {

    &.ah-detail-dialog .el-dialog {
        max-width: 1200px;
        background-color: #f6f6f6;
        padding: 0;
    }
    .action-bar {
        padding: 10px 20px;
        background-color: #fff;
        border-bottom: 1px solid #eee;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .table-view-container {
        background-color: #fff;
        padding: 40px 20px;
        border: 1px solid #eee;
        border-radius: 8px;
    }
    .container {
        padding: 40px;
    }
    .right {
        text-align: right;
        margin: 0 20px 20px;
    }
    .pagination {
        text-align: center;
        padding: 40px 0 20px;
    }
}
</style>
